import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { icons } from "../../assets";
import { CustomModal } from "../../components";
import { useMemo, useState } from "react";

const MenuFooter = ({ purple = true }) => {
    const { name } = useSelector((state) => state.auth);
    const proyectSelected = useSelector((state) => state.vrlSlice.proyectSelected);

    const color = useMemo(() => {
        switch (proyectSelected?._id) {
            case "6610c73702c6d8edebbe9154":
            case "66155e601e91fe7bde671941":
                return "text-white";
            case "679965563ed6fed031d3b488":
                return "text-[#FF0000]";
            default:
                return "text-3366FF";
        }
    }, [proyectSelected?._id]);


    const [modalCloseSesion, setmodalCloseSesion] = useState(false)

    const navigate = useNavigate()
    const logOut = () => {
        localStorage.clear()
        navigate("/auth")
    }

    return (
        <div className=" mt-auto pb-6 ">
            <div className="pl-[18px] flex w-full items-center justify-start cursor-default hover:bg-opacity-50 py-2">
                <img className="w-5 ml-[2px]" src={icons.userPurple} alt="icon showin user's name" />
                <p className={`pl-4 text-[#9A9A9A] font-normal text-base`}>{name}</p>
            </div>
            <div
                onClick={() => setmodalCloseSesion(true)}
                className="pl-[18px] flex w-full items-center justify-start cursor-pointer  hover:bg-opacity-50 py-2">
                {/* <img className="w-5 " src={icons.closeSessionPurple} alt=" showin user's name" />
                 */}
                <svg width="19" height="20" viewBox="0 0 19 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.25 7V3.25C7.25 2.65326 7.48705 2.08097 7.90901 1.65901C8.33097 1.23705 8.90326 1 9.5 1H15.5C16.0967 1 16.669 1.23705 17.091 1.65901C17.5129 2.08097 17.75 2.65326 17.75 3.25V16.75C17.75 17.3467 17.5129 17.919 17.091 18.341C16.669 18.7629 16.0967 19 15.5 19H9.5C8.90326 19 8.33097 18.7629 7.90901 18.341C7.48705 17.919 7.25 17.3467 7.25 16.75V13M4.25 13L1.25 10M1.25 10L4.25 7M1.25 10H14"
                        stroke={`${proyectSelected._id === "679965563ed6fed031d3b488" ? "#FF0000" : "#3366FF"}`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <p className={`pl-4 ${color} font-normal text-base`}>Cerrar sesión</p>
            </div>
            <CustomModal isVisible={modalCloseSesion} width={"312px"} height={"168px"} close={() => setmodalCloseSesion(false)} >
                <div className="w-full flex flex-col items-center ">
                    <p className="text-base text-3366FF font-semibold">CERRAR SESIÓN</p>
                    <p className="text-[#9A9A9A] text-xs pt-3">¿Estás seguro que deseas cerrar la sesión?</p>
                    <div className="flex gap-2 pt-5">
                        <button
                            onClick={() => { setmodalCloseSesion(false); }}
                            className="w-[104px] h-[32px] rounded-sm text-3366FF text-base border border-3366FF">Cancelar</button>
                        <button
                            onClick={() => { setmodalCloseSesion(false); logOut() }}
                            className="w-[104px] h-[32px] rounded-sm text-white text-base bg-3366FF">Aceptar</button>
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

export default MenuFooter;
